import compact from 'lodash/compact';
import {TYPE_OTHER} from '../constants';

export const arrayToString = arr =>
  typeof arr === 'object' ? compact(arr).join(', ') : arr;

const formatOnlineGroup = platform => {
  if (platform && platform !== TYPE_OTHER) return platform + ' Group';
  return 'Online Group';
};

export const createDataTable = data =>
  data.map(item => {
    const location = item.GroupLocation;
    const country = location.Country;
    const state = location.State;
    const city = location.City;
    const latLng = location.Position;
    const primaryProducts = arrayToString(item.PrimaryProducts);
    const otherAutodeskProducts = arrayToString(item.OtherAutodeskProducts);
    const otherProducts = arrayToString(item.OtherProducts);
    const isPublishUser = item.PublishGroupLeader;

    return {
      groupId: item.GroupName, // @todo: replace by real id when passed
      groupName: item.GroupName,
      products: item.PrimaryProducts,
      country,
      state,
      city,
      latLng,
      physical: arrayToString([city, state, country]),
      virtual: formatOnlineGroup(item.PrimaryOnlinePlatform),
      language: item.LocalLanguageOfGroup,
      preview: item.GroupStatement,
      allProducts: arrayToString([
        primaryProducts,
        otherAutodeskProducts,
        otherProducts,
      ]),
      otherProducts,
      filterProducts: item.PrimaryProducts,
      meeting: item.MeetingCadence,
      user: {
        name: isPublishUser ? item.PrimaryGroupLeader.Name : '',
        link: isPublishUser ? item.PrimaryGroupLeader.ContactLink : '',
      },
      social: item.GroupSocialMediaChannel,
      link: item.PrimaryGroupWebsiteLink,
      industry: item.IndustryFocus,
      primaryType: item.PrimaryTypeOfGroupInteraction,
      onlinePlatform:
        item.PrimaryOnlinePlatform && item.PrimaryOnlinePlatform !== TYPE_OTHER
          ? item.PrimaryOnlinePlatform
          : TYPE_OTHER,
      numUsers: Number(item.GroupSize),
    };
  });
